<template>
  <v-layout row wrap justify-center align-center class="h-100">
    <v-flex class="text-xs-center dashboard-content">
      <div id="dashboard"></div>
    </v-flex>
  </v-layout>
</template>
<script>
import moment from 'moment';
import { embedDashboard } from 'amazon-quicksight-embedding-sdk';
import EventBus from '@/event-bus';

export default {
  mounted() {
    EventBus.$emit('hideMenu');
    this.getQuick();
  },
  data: () => ({
    url: '',
    apiUrl: '',
  }),
  computed: {
    company() {
      return this.$auth.user().company.name;
    },
  },
  methods: {
    getQuick() {
      this.axios.get(`dashboards/${this.$route.params.id}`).then(({ data }) => {
        const containerDiv = document.getElementById('dashboard');
        const options = {
          url: data.embedUrl,
          container: containerDiv,
          parameters: {
            company: this.company,
            quicksight: data.quicksight_key,
            fecha: `${moment().format('YYYY-MM-DD')} 00:00`,
            fechainicio: `${moment().format('YYYY-MM-DD')} 00:00`,
          },
        };
        const dashboard = embedDashboard(options);
        dashboard.on('error', (data2) => {
          console.error(data2); // eslint-disable-line
        });
        dashboard.on('load', (data2) => {
          // console.log(data2); // eslint-disable-line
        });
      });
    },
  },
};
</script>
<style scoped>
  #dashboard {
    width: 100%;
    height: 85vh;
    border: 0px;
    padding-left: 18px;
    padding-right: 18px;
    padding-top: 0;
  }
  .dashboard-content {
    height: calc(100% - 36px);
    display: flex;
    align-items: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/dashboards/CallCenter.vue